import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';
import * as oPath from '../../../Lib/Object/Path/Immutable';

const HammerEquipment = () => {
  const faceType = useSelector((state) => oPath.get(state.equipment.syncModel, 'data.FaceType'));
  return (
    <>
      <PageSection heading="Hammer">
        <ListFieldSection>
          <Field input={<TextOutput />} label="Hammer" name="Code" />
          <Field
            input={<RadioGroup />}
            label="Hammer Operation"
            name="Operation"
            options={['Automatic', 'Manual'].map((e) => ({ label: e, value: e }))}
          />
          <Field
            input={<RadioGroup />}
            label="Face Type"
            name="FaceType"
            options={[
              { label: 'Circular', value: 'circular' },
              { label: 'Sector (Pie)', value: 'sector' },
            ]}
          />
          <Field
            input={<RadioGroup />}
            label="Face Nominal Measurement Units"
            name="NominalUnits"
            options={[
              { label: 'in', value: 'Inch-Pound' },
              { label: 'mm', value: 'Metric' },
            ]}
          />

          <Field
            input={<NumericInput />}
            label="Face Nominal Diameter"
            name="FaceDiameter"
            visible={faceType === 'circular'}
          />
          <Field
            input={<NumericInput />}
            label="Face Nominal Radius"
            name="FaceRadius"
            visible={faceType === 'sector'}
          />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default HammerEquipment;
export { HammerEquipment };
